const Mutations = Object.freeze({
	SET_PROJECTS: 'projectContext/SET_PROJECTS',
	SET_SELECTED_PROJECT: 'projectContext/SET_SELECTED_PROJECT',
	SET_SELECTED_PROJECT_SETTINGS:
		'projectContext/SET_SELECTED_PROJECT_SETTINGS',
	SET_NOTIFICATIONS: 'projectContext/SET_NOTIFICATIONS',
	APPEND_NOTIFICATIONS: 'projectContext/APPEND_NOTIFICATIONS',
	SET_NOTIFICATIONS_LOADING: 'projectContext/SET_NOTIFICATIONS_LOADING',
	SET_NOTIFICATIONS_HAS_MORE: 'projectContext/SET_NOTIFICATIONS_HAS_MORE',
	SET_NOTIFICATIONS_UNREAD_COUNT:
		'projectContext/SET_NOTIFICATIONS_UNREAD_COUNT',
	RESET_NOTIFICATIONS_PAGINATION:
		'projectContext/RESET_NOTIFICATIONS_PAGINATION',
	MARK_NOTIFICATION_AS_READ: 'projectContext/MARK_NOTIFICATION_AS_READ',
	MARK_SELECTED_NOTIFICATIONS_AS_READ:
		'projectContext/MARK_SELECTED_NOTIFICATIONS_AS_READ',
	DELETE_SELECTED_NOTIFICATIONS:
		'projectContext/DELETE_SELECTED_NOTIFICATIONS',
});

export const Actions = Object.freeze({
	LOAD_PROJECT_CONTEXT: 'projectContext/LOAD_PROJECT_CONTEXT',
	RELOAD_PROJECT_CONTEXT: 'projectContext/RELOAD_PROJECT_CONTEXT',
	UPDATE_SELECTED_PROJECT: 'projectContext/UPDATE_SELECTED_PROJECT',
	LOAD_PROJECT_SETTINGS: 'projectContext/LOAD_PROJECT_SETTINGS',
	LOAD_NOTIFICATIONS: 'projectContext/LOAD_NOTIFICATIONS',
	REFRESH_NOTIFICATIONS: 'projectContext/REFRESH_NOTIFICATIONS',
	LOAD_MORE_NOTIFICATIONS: 'projectContext/LOAD_MORE_NOTIFICATIONS',
	DELETE_NOTIFICATION: 'projectContext/DELETE_NOTIFICATION',
	MARK_NOTIFICATION_AS_READ: 'projectContext/MARK_NOTIFICATION_AS_READ',
	MARK_ALL_NOTIFICATIONS_AS_READ:
		'projectContext/MARK_ALL_NOTIFICATIONS_AS_READ',
	MARK_SELECTED_NOTIFICATIONS_AS_READ:
		'projectContext/MARK_SELECTED_NOTIFICATIONS_AS_READ',
	DELETE_SELECTED_NOTIFICATIONS:
		'projectContext/DELETE_SELECTED_NOTIFICATIONS',
	CLEAR: 'projectContext/CLEAR',
});

export const Getters = Object.freeze({
	PROJECTS: 'projectContext/PROJECTS',
	SELECTED_PROJECT: 'projectContext/SELECTED_PROJECT',
	HAS_PROJECT: 'projectContext/HAS_PROJECT',
	PROJECT_SETTINGS: 'projectContext/PROJECT_SETTINGS',
	NOTIFICATIONS: 'projectContext/NOTIFICATIONS',
	NOTIFICATIONS_LOADING: 'projectContext/NOTIFICATIONS_LOADING',
	NOTIFICATIONS_HAS_MORE: 'projectContext/NOTIFICATIONS_HAS_MORE',
	NOTIFICATIONS_UNREAD_COUNT: 'projectContext/NOTIFICATIONS_UNREAD_COUNT',
});

import dataService from '../../../../services/data/userContextDataService';
import {
	GeneralActions,
	GridsActions,
	InventoryFormActions,
	ProjectSettingsActions,
	GeneralSettingsActions,
	ActivityActions,
	ReportActions,
} from '../../../actions';
import settings from './projectSettings/projectSettings';
import grids from './gridsModule/grids';
import inventoryFormModule from './inventoryForm/inventoryFormModule';
import dataImport from './dataImport/dataImport';
import dataExports from './dataExports/dataExports';
import reportBuilderModule from './reportBuilder/reportBuilderModule';
import reports from './reports/reports';
import activityBuilder from './activityModule/activityBuilder';
import activity from './activityModule/activity';

import signalRService from '../../../../signalR/signalRService';

export default {
	state: {
		projects: [],
		selectedProject: null,
		selectedProjectSettings: [],
		notifications: [],
		notificationsLoading: false,
		notificationsHasMore: true,
		notificationsSkip: 0,
		notificationsPageSize: 25,
		notificationsUnreadCount: 0,
	},
	modules: {
		settings,
		grids,
		inventoryFormModule,
		dataImport,
		reportBuilderModule,
		reports,
		activity,
		activityBuilder,
		dataExports,
	},
	mutations: {
		[Mutations.SET_NOTIFICATIONS](state, items) {
			state.notifications = items;
			state.notificationsSkip = items.length;
		},
		[Mutations.APPEND_NOTIFICATIONS](state, items) {
			state.notifications = [...state.notifications, ...items];
			state.notificationsSkip += items.length;
		},
		[Mutations.SET_NOTIFICATIONS_LOADING](state, loading) {
			state.notificationsLoading = loading;
		},
		[Mutations.SET_NOTIFICATIONS_HAS_MORE](state, hasMore) {
			state.notificationsHasMore = hasMore;
		},
		[Mutations.SET_NOTIFICATIONS_UNREAD_COUNT](state, count) {
			state.notificationsUnreadCount = count;
		},
		[Mutations.RESET_NOTIFICATIONS_PAGINATION](state) {
			state.notificationsSkip = 0;
			state.notificationsLoading = false;
			state.notificationsHasMore = true;
		},
		[Mutations.MARK_NOTIFICATION_AS_READ](state, notificationId) {
			const notification = state.notifications.find(
				(n) => n.Id === notificationId
			);
			if (notification) {
				notification.IsRead = true;
			}
		},
		[Mutations.MARK_SELECTED_NOTIFICATIONS_AS_READ](
			state,
			notificationIds
		) {
			state.notifications.forEach((notification) => {
				if (notificationIds.includes(notification.Id)) {
					notification.IsRead = true;
				}
			});
		},
		[Mutations.DELETE_SELECTED_NOTIFICATIONS](state, notificationIds) {
			state.notifications = state.notifications.filter(
				(notification) => !notificationIds.includes(notification.Id)
			);
			state.notificationsSkip = state.notifications.length;
		},
		[Mutations.SET_PROJECTS](state, items) {
			state.projects = items;
		},
		[Mutations.SET_SELECTED_PROJECT](state, item) {
			state.selectedProject = item;
		},
		[Mutations.SET_SELECTED_PROJECT_SETTINGS](state, items) {
			state.selectedProjectSettings = items;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit, dispatch }) {
			return new Promise((resolve) => {
				Promise.all([
					dispatch(ProjectSettingsActions.CLEAR),
					dispatch(GridsActions.CLEAR),
					dispatch(InventoryFormActions.CLEAR),
					signalRService.stopConnection(),
				]).then(() => {
					commit(Mutations.SET_SELECTED_PROJECT, null);
					commit(Mutations.SET_SELECTED_PROJECT_SETTINGS, []);
					commit(Mutations.SET_PROJECTS, []);
					commit(Mutations.SET_NOTIFICATIONS, []);
					commit(Mutations.SET_NOTIFICATIONS_UNREAD_COUNT, 0);
					commit(Mutations.RESET_NOTIFICATIONS_PAGINATION);
					resolve();
				});
			});
		},

		[Actions.LOAD_PROJECT_CONTEXT]({ commit, dispatch }) {
			return new Promise((resolve) => {
				Promise.all([
					dataService.getProjects().then((resp) => {
						commit(Mutations.SET_PROJECTS, resp.data);
					}),
					dataService.getSelectedProject().then((resp) => {
						if (resp.data) {
							Promise.all([
								dispatch(GridsActions.LOAD_GRIDS),
								dispatch(ActivityActions.LOAD_ACTIVITIES),
								dispatch(
									InventoryFormActions.LOAD_INVENTORY_FORMS
								),
								dispatch(
									ReportActions.LOAD_ADMIN_REPORT_PREVIEWS
								),
								dispatch(ReportActions.LOAD_REPORT_PREVIEWS),
								dispatch(Actions.LOAD_PROJECT_SETTINGS),
								dispatch(Actions.LOAD_NOTIFICATIONS),
							]).then(() => {
								commit(
									Mutations.SET_SELECTED_PROJECT,
									resp.data
								);
								signalRService.startConnection(),
									signalRService.onNotification(() => {
										dispatch(Actions.REFRESH_NOTIFICATIONS);
									});
								resolve();
							});
						} else {
							resolve();
						}
					}),
				]).catch((error) => {
					dispatch(GeneralActions.ERROR, error);
				});
			});
		},

		[Actions.LOAD_PROJECT_SETTINGS]({ commit, dispatch }) {
			return dataService.getSelectedProjectSettings().then((resp) => {
				dispatch(GeneralSettingsActions.LOAD_SETTINGS);
				commit(Mutations.SET_SELECTED_PROJECT_SETTINGS, resp.data);
			});
		},

		[Actions.UPDATE_SELECTED_PROJECT]({ dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateSelectedProject(item)
					.then(() => {
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},

		[Actions.RELOAD_PROJECT_CONTEXT]({ dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dispatch(Actions.CLEAR)
					.then(() => {
						return dispatch(Actions.LOAD_PROJECT_CONTEXT);
					})
					.then(() => {
						resolve(true);
					})
					.catch(() => {
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.LOAD_NOTIFICATIONS]({ commit, dispatch, state }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_NOTIFICATIONS_LOADING, true);
				dataService
					.getNotifications(0, state.notificationsPageSize)
					.then((resp) => {
						// Handle both old format (resp.data as array) and new format (resp.data as object)
						const notifications = resp.data.data || resp.data;
						const unreadCount = resp.data.totalUnreadCount || 0;

						commit(Mutations.SET_NOTIFICATIONS, notifications);
						commit(
							Mutations.SET_NOTIFICATIONS_UNREAD_COUNT,
							unreadCount
						);
						commit(
							Mutations.SET_NOTIFICATIONS_HAS_MORE,
							notifications.length === state.notificationsPageSize
						);
						resolve(notifications);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve([]);
					})
					.finally(() => {
						commit(Mutations.SET_NOTIFICATIONS_LOADING, false);
					});
			});
		},

		[Actions.LOAD_MORE_NOTIFICATIONS]({ commit, dispatch, state }) {
			return new Promise((resolve) => {
				if (state.notificationsLoading || !state.notificationsHasMore) {
					resolve(false);
					return;
				}

				commit(Mutations.SET_NOTIFICATIONS_LOADING, true);
				dataService
					.getNotifications(
						state.notificationsSkip,
						state.notificationsPageSize
					)
					.then((resp) => {
						// Handle both old format (resp.data as array) and new format (resp.data as object)
						const notifications = resp.data.data || resp.data;
						if (notifications && notifications.length > 0) {
							commit(
								Mutations.APPEND_NOTIFICATIONS,
								notifications
							);
							commit(
								Mutations.SET_NOTIFICATIONS_HAS_MORE,
								notifications.length ===
									state.notificationsPageSize
							);
						} else {
							commit(Mutations.SET_NOTIFICATIONS_HAS_MORE, false);
						}
						// Update unread count if provided
						if (resp.data.totalUnreadCount !== undefined) {
							commit(
								Mutations.SET_NOTIFICATIONS_UNREAD_COUNT,
								resp.data.totalUnreadCount
							);
						}
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						commit(Mutations.SET_NOTIFICATIONS_LOADING, false);
					});
			});
		},

		[Actions.REFRESH_NOTIFICATIONS]({ commit, dispatch, state }) {
			return new Promise((resolve) => {
				// Only refresh if we're not in the middle of pagination
				if (state.notificationsLoading) {
					resolve(false);
					return;
				}

				commit(Mutations.SET_NOTIFICATIONS_LOADING, true);
				// Load all notifications we currently have (to preserve pagination state)
				const currentCount = state.notifications.length;
				const loadCount = Math.max(
					currentCount,
					state.notificationsPageSize
				);

				dataService
					.getNotifications(0, loadCount)
					.then((resp) => {
						// Handle both old format (resp.data as array) and new format (resp.data as object)
						const notifications = resp.data.data || resp.data;
						const unreadCount =
							resp.data.totalUnreadCount ||
							state.notificationsUnreadCount;

						commit(Mutations.SET_NOTIFICATIONS, notifications);
						commit(
							Mutations.SET_NOTIFICATIONS_UNREAD_COUNT,
							unreadCount
						);
						commit(
							Mutations.SET_NOTIFICATIONS_HAS_MORE,
							notifications.length === loadCount &&
								loadCount >= state.notificationsPageSize
						);
						resolve(notifications);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve([]);
					})
					.finally(() => {
						commit(Mutations.SET_NOTIFICATIONS_LOADING, false);
					});
			});
		},

		[Actions.DELETE_NOTIFICATION](
			{ commit, dispatch, state },
			notificationId
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteNotification(notificationId)
					.then(() => {
						const updatedNotifications = state.notifications.filter(
							(n) => n.Id !== notificationId
						);
						commit(
							Mutations.SET_NOTIFICATIONS,
							updatedNotifications
						);

						// Refresh unread count after deletion
						dataService
							.getUnreadNotificationsCount()
							.then((resp) => {
								commit(
									Mutations.SET_NOTIFICATIONS_UNREAD_COUNT,
									resp.data.count
								);
							})
							.catch(() => {
								// If unread count fetch fails, just decrement by 1 as fallback
								const newCount = Math.max(
									0,
									state.notificationsUnreadCount - 1
								);
								commit(
									Mutations.SET_NOTIFICATIONS_UNREAD_COUNT,
									newCount
								);
							});

						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},

		[Actions.MARK_NOTIFICATION_AS_READ](
			{ commit, dispatch },
			notificationId
		) {
			return new Promise((resolve) => {
				dataService
					.markNotificationAsRead(notificationId)
					.then((resp) => {
						commit(
							Mutations.MARK_NOTIFICATION_AS_READ,
							notificationId
						);
						if (resp.data.totalUnreadCount !== undefined) {
							commit(
								Mutations.SET_NOTIFICATIONS_UNREAD_COUNT,
								resp.data.totalUnreadCount
							);
						}
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					});
			});
		},

		[Actions.MARK_ALL_NOTIFICATIONS_AS_READ]({ commit, dispatch, state }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.markAllNotificationsAsRead()
					.then((resp) => {
						// Mark all current notifications as read
						const updatedNotifications = state.notifications.map(
							(notification) => ({
								...notification,
								IsRead: true,
							})
						);
						commit(
							Mutations.SET_NOTIFICATIONS,
							updatedNotifications
						);

						if (resp.data.totalUnreadCount !== undefined) {
							commit(
								Mutations.SET_NOTIFICATIONS_UNREAD_COUNT,
								resp.data.totalUnreadCount
							);
						}
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},

		[Actions.MARK_SELECTED_NOTIFICATIONS_AS_READ](
			{ commit, dispatch },
			notificationIds
		) {
			return new Promise((resolve) => {
				if (!notificationIds || notificationIds.length === 0) {
					resolve(false);
					return;
				}

				dispatch(GeneralActions.LOADING, true);
				dataService
					.markSelectedNotificationsAsRead(notificationIds)
					.then((resp) => {
						commit(
							Mutations.MARK_SELECTED_NOTIFICATIONS_AS_READ,
							notificationIds
						);

						if (resp.data.totalUnreadCount !== undefined) {
							commit(
								Mutations.SET_NOTIFICATIONS_UNREAD_COUNT,
								resp.data.totalUnreadCount
							);
						}
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},

		[Actions.DELETE_SELECTED_NOTIFICATIONS](
			{ commit, dispatch },
			notificationIds
		) {
			return new Promise((resolve) => {
				if (!notificationIds || notificationIds.length === 0) {
					resolve(false);
					return;
				}

				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteSelectedNotifications(notificationIds)
					.then((resp) => {
						commit(
							Mutations.DELETE_SELECTED_NOTIFICATIONS,
							notificationIds
						);

						if (resp.data.totalUnreadCount !== undefined) {
							commit(
								Mutations.SET_NOTIFICATIONS_UNREAD_COUNT,
								resp.data.totalUnreadCount
							);
						}
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
	},
	getters: {
		[Getters.PROJECTS]: (state) => {
			return JSON.parse(JSON.stringify(state.projects));
		},
		[Getters.SELECTED_PROJECT]: (state) => {
			if (!state.selectedProject) return null;
			return JSON.parse(JSON.stringify(state.selectedProject));
		},
		[Getters.HAS_PROJECT]: (state) => {
			return state.selectedProject != null;
		},
		[Getters.PROJECT_SETTINGS]: (state) => {
			if (!state.selectedProjectSettings) return [];
			if (state.selectedProjectSettings.length <= 0) return [];
			return JSON.parse(JSON.stringify(state.selectedProjectSettings));
		},
		[Getters.NOTIFICATIONS]: (state) => {
			if (!state.notifications) return [];
			return JSON.parse(JSON.stringify(state.notifications));
		},
		[Getters.NOTIFICATIONS_LOADING]: (state) => {
			return state.notificationsLoading;
		},
		[Getters.NOTIFICATIONS_HAS_MORE]: (state) => {
			return state.notificationsHasMore;
		},
		[Getters.NOTIFICATIONS_UNREAD_COUNT]: (state) => {
			return state.notificationsUnreadCount;
		},
	},
};
